import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Community } from './Community';
import { WhyPlaycast } from './WhyPlaycast';
import { CookieManager } from './CookieManager';
import { Footer } from '@playcastdotio/Footer';

export const Content = () => {
  const m = useLocation();

  return (
    <main className='relative'>
      <CookieManager>
        <div>
          <div className='flex-grow'>
            {['/io', '/jo', '/j/'].includes(m.pathname.substring(0, 3)) ? (
              <Outlet />
            ) : (
              <>
                <Header />
                <div data-testid='outlet'>
                  <Outlet />
                </div>
                {['/ux', '/di'].includes(m.pathname.substring(0, 3)) ? <WhyPlaycast /> : <Community />}
              </>
            )}
          </div>
          <Footer />
        </div>
      </CookieManager>
    </main>
  );
};

